export default __webpack_public_path__ + "static/media/sandmix.f9499ba4.png";